import {
    useMemo,
} from 'react'
import FormWithControls from 'app/shared-components/FormWithControls'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import {
    RateCardStatus,
} from 'app/enums/label.enums'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    RequestConfig,
} from 'app/types/request.types'

import {
    ARateCardFormValue,
} from './ARateCardForm.types'
import useStyles from './ARateCardForm.styles'
import aRateCardFormFields from './ARateCardForm.fields'

type Props = {
    disabled?: boolean,
    value?: Partial<ARateCardFormValue>,
    onSuccess: (...a: any[]) => void,
    requestParams: RequestConfig,
    getCustomButtons?: (params: {
        isValid: boolean,
        edited: boolean,
    }) => JSX.Element[],
}

const defaultValue = {
    status: RateCardStatus.IN_PROGRESS,
}

export default function ARateCardForm({
    disabled = false,
    value = defaultValue,
    onSuccess,
    requestParams,
    getCustomButtons = undefined,
}: Readonly<Props>) {
    const getAllowedValues = useEnumValues()

    const exists = Boolean(value?.id)

    const isEditDisabled = disabled || (exists && value?.status !== RateCardStatus.IN_PROGRESS)

    const isValidFromEditable = !disabled && (value?.status === RateCardStatus.IN_PROGRESS)

    const formFields = useMemo(() => {
        return aRateCardFormFields({
            getAllowedValues,
            isEditDisabled,
            exists,
            isValidFromEditable,
        })
    }, [
        getAllowedValues,
        isEditDisabled,
        exists,
        isValidFromEditable,
    ])

    const fieldsCount = useMemo(() => {
        return formFields[0].fields.filter((field) => {
            return !field.hidden
        }).length
    }, [formFields])

    const {
        classes,
    } = useStyles({
        fieldsCount,
    })

    const fields = useFieldsWithClassName(
        formFields,
        classes,
    )

    return (
        <FormWithControls
            name="ARateCardForm"
            value={value}
            onSuccess={onSuccess}
            fields={fields}
            requestParams={requestParams}
            exists={exists}
            getCustomButtons={getCustomButtons}
            canCancel={!isEditDisabled || isValidFromEditable}
            canUpdate={!isEditDisabled || isValidFromEditable}
        />
    )
}
